import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function isShowSerieLabel(name: string | undefined, settings: ChartStyleSettings) {
  return settings.series?.find((s) => s.name === name)?.showLabel !== false;
}
